import { apiPyAxios } from "../api/axios";

const unwrap = (res) => res.data?.results ?? res.data ?? [];

export const getBlogs = async ({ langId, pageSize = 500 }, signal) => {
  const res = await apiPyAxios.get("blogs/", {
    params: { lang: langId, page_size: pageSize },
    signal,
  });

  const blogs = unwrap(res);

  return blogs.sort((a, b) => (a.priority || 0) - (b.priority || 0));
};

export const getBlogById = async (id, signal) => {
  const res = await apiPyAxios.get(`blogs/${id}/`, { signal });
  return res.data;
};
